export function formatCurrencyAmount(
  amount?: number | string | null,
  currency?: string | null,
  locale: string = 'en-US'
): string | undefined {
  if (amount === null || amount === undefined) {
    return undefined
  }

  const numeric =
    typeof amount === 'string'
      ? amount.trim() === ''
        ? NaN
        : Number(amount.replace(/,/g, ''))
      : typeof amount === 'number'
        ? amount
        : NaN

  if (!Number.isFinite(numeric)) {
    return undefined
  }

  const safeCurrency = currency ? currency.toUpperCase() : undefined

  try {
    const formatter = new Intl.NumberFormat(locale, {
      maximumFractionDigits: 0,
    })

    const formatted = formatter.format(numeric)
    return safeCurrency ? `${safeCurrency} ${formatted}` : formatted
  } catch {
    const fallback = Math.round(numeric).toString()
    return safeCurrency ? `${safeCurrency} ${fallback}` : fallback
  }
}
